// extracted by mini-css-extract-plugin
export default {"blogButtons":"blog_blogButtons__iKDsV"};